import React, { useEffect, useState } from "react";
import WebsiteTestimonials from "../../common/websitetestimonials";
import Inquiry from "../../common/inquiry";
import { useTranslation } from "react-i18next";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import { GetMGModules, GetMGPanels } from "../../services/website.services";
import Skeleton from "react-loading-skeleton";
import { getLocalKey, TrimText } from "../../../../utils/commonfunction";

export default function ManualGuideLayout() {
  const { t } = useTranslation();
  const param = useParams();
  const location = useLocation();
  const [panelDataLoaded, setPanelDataLoaded] = useState(false);
  const [panel, setPanel] = useState({});
  const [module, setModules] = useState([]);
  const [modulesDataLoaded, setModulesDataLoaded] = useState(false);
  const [currentModule, setCurrentModule] = useState({});

  useEffect(() => { 
    setPanelDataLoaded(false);
        GetMGPanels(param.slug).then((response) => {
          if (response.success) {
            setPanel(response.data);
          }
        }).catch((err) => {
          console.error(err);
        }).finally(() => { setPanelDataLoaded(true) });
  }, [getLocalKey("system_language")]);

  useEffect(() => {
    GetMGModules(param.slug).then((response) => {
      if (response.success) {
        setModules(response.data);
      }
    }).catch((err) => {
      console.error(err);
    }).finally(() => { setModulesDataLoaded(true) });
  }, [getLocalKey("system_language")]);
  useEffect(() => {
    GetMGModules(param.slug, param.moduleSlug).then((response) => {
      if (response.success) {
        setCurrentModule(response.data);
      }
    }).catch((err) => {
      console.error(err);
    }).finally(() => { setModulesDataLoaded(true) });
  }, [location , getLocalKey("system_language")]);

  return (
    <div className="manual-guide-page">
      <div className="manual-guide-view py-5">
        <div className="container">
          <div className="row">
            <div className="col-4">
              {
                !modulesDataLoaded ? 
                (<div>

                <Skeleton className={"d-block rounded-4 mx-3"} height={50} count={4} />
                </div>) :
              
              <div id="list-example" className="list-group">
                {module?.map((item, index) => {
                  return (
                    <Link key={index} className={"list-group-item list-group-item-action" + (param.moduleSlug === item.slug ? " active" : "")} to={`/manual-guide-details/${param.slug}/${item.slug}?i=${index}`}>
                      {index+1}. {t(item?.title)}
                    </Link>
                  );
                })}
              </div>
              }
            </div>
            <div className="col-8">
              <div data-bs-spy="scroll" data-bs-target="#list-example" data-bs-smooth-scroll="true" className="scrollspy-example" tabIndex="0">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      {t(panel?.breadcrumb_title)}
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {t(currentModule?.title)}
                    </li>
                  </ol>
                </nav>

                <div className="right-part-guide">
                  <div id="list-item-1">
                    <h4>{TrimText(t(panel?.title),25)}</h4>
                    <p>{t(panel?.description)}</p>
                  </div>
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <WebsiteTestimonials id="testimonial-2" />
      <Inquiry id="inquiry-2" />
    </div>
  );
}
